import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { TitulacoesQuery, TitulacoesQueryVariables } from './__generated__/TitulacoesQuery';

const TITULACOES_QUERY = gql`
  query TitulacoesQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    titulacoes(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_titulacao
      dsc_titulacao
    }
  }
`;

const useTitulacoesQuery = (variables: TitulacoesQueryVariables) => {
  return useQuery<TitulacoesQuery, TitulacoesQueryVariables>(TITULACOES_QUERY, {
    variables,
  });
};

const useTitulacoesLazyQuery = () => {
  return useLazyQuery<TitulacoesQuery, TitulacoesQueryVariables>(TITULACOES_QUERY);
};

export { useTitulacoesQuery, useTitulacoesLazyQuery };
